import { render, staticRenderFns } from "./SchoolApplyEdit.vue?vue&type=template&id=1c1d0bc3&scoped=true"
import script from "./SchoolApplyEdit.vue?vue&type=script&lang=js"
export * from "./SchoolApplyEdit.vue?vue&type=script&lang=js"
import style0 from "./SchoolApplyEdit.vue?vue&type=style&index=0&id=1c1d0bc3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d0bc3",
  null
  
)

export default component.exports